require('./square.scss');

const PropTypes = require('prop-types');

const React = require('react');
const classNames = require('classnames');

const Square = props => {
    const { active } = props;
    const className = classNames('ok-square', {
        'ok-square--active': active
    });
    return (
        <i className={className} />
    );
};

Square.propTypes = {
    active: PropTypes.bool.isRequired,
}

module.exports = Square;